import { Toastr } from 'components/global/Toastr'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'
import { CreateJobApplicationResponse, JobApplicantResponse } from './actions'

export type actionType = 'createApplicant' | 'getApplicant' | ''

type InitialStateType = {
  response: JobApplicantResponse | CreateJobApplicationResponse
  fetching: boolean
  action: actionType
}

const initialState: InitialStateType = {
  response: {
    data: {
      workflow_stages: [],
      all_candidate_ids: [],
    },
    success: false,
    statusCode: 0,
  },
  action: '',
  fetching: false,
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.CREATE_JOB_APPLICANT_PENDING:
    case actions.GET_JOB_APPLICANTS_PENDING: {
      return {
        ...state,
        action: '',
        response: {
          ...state.response,
          success: false,
        },
        fetching: true,
      }
    }

    case actions.CREATE_JOB_APPLICANT_FULFILLED:
    case actions.GET_JOB_APPLICANTS_FULFILLED: {
      return {
        ...state,
        response: { ...action?.payload?.data },
        fetching: false,
        action:
          action.type === 'CREATE_JOB_APPLICANT_FULFILLED' ? 'createApplicant' : 'getApplicant',
      }
    }

    case actions.CREATE_JOB_APPLICANT_REJECTED:
    case actions.GET_JOB_APPLICANTS_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
        action: '',
      }
    }
    default:
      return state
  }
}
